import { t } from "@lingui/macro"
import { FormControlLabel, Stack, Switch } from "@mui/material"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { FormFieldSet } from "src/components/FormFieldSet"
import { FormDetailStore } from "src/modals/contact-forms-form-builder/store"
import { useStore } from "src/store/lib/useStore"

export const UIVisibilitySection = observer(() => {
    const store = useStore(FormDetailStore)

    const handleUIVisibilityChange = useCallback(
        (_: unknown, checked: boolean) => {
            store.formFields.set("showInUI", checked)
        },
        [store.formFields],
    )

    const statusLabel = Boolean(store.formFields.get("showInUI"))
        ? t`contact-form-forms-detail-modal.show-in-ui.value-enabled`
        : t`contact-form-forms-detail-modal.show-in-ui.value-disabled`

    return (
        <FormFieldSet>
            <Stack spacing={2}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={store.formFields.get("showInUI")}
                            onChange={handleUIVisibilityChange}
                            color="success"
                        />
                    }
                    label={statusLabel}
                />
            </Stack>
        </FormFieldSet>
    )
})
